<div class="status-select-container">
  <div class="status-badge" (click)="toggleDropdown($event)" [ngClass]="{'loading': isLoading}" [ngStyle]="{
      'background-color': getChipBackgroundColor(currentStatus.color),
      'color': '#000000'
    }">
    <span class="status-indicator" [ngStyle]="{'background-color': currentStatus.color}"></span>
    <span class="status-text">{{ currentStatus.name | titlecase }}</span>
    <span class="loading-spinner" *ngIf="isLoading"></span>
  </div>
  
  <div class="status-dropdown" *ngIf="isOpen" [style.position]="'fixed'" 
       [style.top.px]="dropdownPosition?.top" 
       [style.left.px]="dropdownPosition?.left">
    <div class="dropdown-title">{{ 'request_v2.list.status_select.dropdown_title' | translate }}</div>
    <div class="status-menu">
      <div class="status-option" 
          *ngFor="let status of statuses" 
          (click)="selectStatus(status, $event)"
          [class.active]="status._id === currentStatus._id">
        <div class="status-option-badge" [ngStyle]="{
            'background-color': getChipBackgroundColor(status.color),
            'color': '#000000'
          }">
          <span class="status-option-indicator" [ngStyle]="{'background-color': status.color}"></span>
          {{ status.name | titlecase }}
        </div>
      </div>
    </div>
  </div>
</div>
